import { render, staticRenderFns } from "./EditTabAccountJson.vue?vue&type=template&id=612dfe4a&"
import script from "./EditTabAccountJson.vue?vue&type=script&lang=js&"
export * from "./EditTabAccountJson.vue?vue&type=script&lang=js&"
import style0 from "./EditTabAccountJson.vue?vue&type=style&index=0&id=612dfe4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports